export enum CategoryProductsUserActions {
  navigate_to_category,
  navigate_to_featured_group,
  product_search,
}
